import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=fa9c4d44&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9c4d44",
  null
  
)

export default component.exports